var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherHumidityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2lt28l9o4a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#2lt28l9o4a)",
    transform: "translate(-557 -137) translate(546 127)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#E36510",
    strokeWidth: 2,
    d: "M56 46.481c0 8.693-6.965 15.741-15.556 15.741-8.59 0-15.555-7.048-15.555-15.74 0-8.693 15.555-28.704 15.555-28.704S56 37.788 56 46.48z",
    transform: "translate(11 10)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherHumidityIcon);
export default __webpack_public_path__ + "static/media/weather-humidity-icon.5b17cc2f1feed5878c3fec8f7e61ccbe.svg";
export { ForwardRef as ReactComponent };